import { capitalAgGridTheme } from '@opengov/capital-ag-grid-theme';
import { iconSetMaterial, themeQuartz } from 'ag-grid-enterprise';

/*
 * https://blog.ag-grid.com/introducing-our-new-theming-api/
 * https://www.ag-grid.com/react-data-grid/theming-api/
 * AG Grid: "In the future it will become the primary way to style the grid."
 */

export const ogGridTheme = themeQuartz.withPart(iconSetMaterial).withParams(capitalAgGridTheme());
